var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Newspapers',
        to: {
          name: _vm.NewspaperCreatePath.name
        }
      }],
      "title": "All Newspapers"
    }
  }), _c('div', {
    staticClass: "flex-col w-full bg-white shadow-sm rounded-lg"
  }, [_c('div', {
    staticClass: "w-full flex items-center justify-between rounded-lg px-4 my-3 py-3"
  }, [_c('div', {
    staticClass: "w-2/6 relative"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-400 text-xl absolute top-2 left-3"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query_search,
      expression: "query_search"
    }],
    staticClass: "p-2.5 pl-5 mb-1 w-full text-sm border rounded-lg",
    attrs: {
      "placeholder": "Search by Newspaper Name or ID",
      "type": "search"
    },
    domProps: {
      "value": _vm.query_search
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.query_search = $event.target.value;
      }, _vm.onSearch],
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch.apply(null, arguments);
      }
    }
  }), _vm.typing ? _c('small', {
    staticClass: "pt-3"
  }, [_c('em', [_vm._v(" typing ... ")])]) : _vm._e()]), _c('div', {
    staticClass: "relative w-3/4 flex justify-end"
  }, [_c('button', {
    staticClass: "text-gray-500 mr-3 bg-blue-700 border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center",
    attrs: {
      "type": "button"
    }
  }, [_c('router-link', {
    staticClass: "text-white px-1 py-2",
    attrs: {
      "to": {
        name: _vm.NewspaperCreatePath.name
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New ")])], 1), _c('button', {
    staticClass: "text-gray-500 flex justify-start items-center mr-3 bg-white border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
  }, [_c('span', [_c('svg', {
    staticClass: "w-6 h-6 p-0 text-gray-800 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z",
      "clip-rule": "evenodd"
    }
  })])]), _c('router-link', {
    staticClass: "px-1 text-gray-500",
    attrs: {
      "to": {
        name: _vm.NewspaperEditBulky.name
      }
    }
  }, [_c('span', [_vm._v(" Bulk Edit Printed Price ")])])], 1), _c('button', {
    staticClass: "text-gray-500 bg-white border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-filter"
  }), _vm._v(" Filter "), _c('i', {
    staticClass: "fa-solid fa-chevron-down"
  })]), _c('FilterComponent', {
    attrs: {
      "isDropdownVisible": _vm.isDropdownVisible
    },
    on: {
      "update:isDropdownVisible": function ($event) {
        _vm.isDropdownVisible = $event;
      },
      "update:is-dropdown-visible": function ($event) {
        _vm.isDropdownVisible = $event;
      },
      "reloadPage": _vm.reloadPage,
      "input": _vm.handleFilterInput
    }
  })], 1)]), _c('div', [_c('TableBooks', {
    staticClass: "border-b border-gray-50",
    attrs: {
      "id": "my-table",
      "books": _vm.Newspaper,
      "currentPage": _vm.currentPage,
      "perPage": _vm.perPage,
      "isLoading": _vm.isLoading,
      "reloadPage": _vm.reloadPage
    },
    on: {
      "sort-by": _vm.handleSortBy
    }
  })], 1), _c('div', {
    staticClass: "flex bg-white justify-between pl-5 pr-3 pt-4 mb-5 border-t border-gray-100 mt-1"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(_vm.formatPriceBasic(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.onClickPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }